import React from 'react';
import '../styles/App.css';

const Conference = () => {
  const eventTypes = [
    "Business meetings",
    "Workshops and seminars",
    "Training sessions",
    "Small conferences"
  ];

  const features = [
    {
      icon: "🏢",
      title: "Spacious Hall",
      description: "Well-ventilated and spacious conference hall"
    },
    {
      icon: "🪑",
      title: "Comfortable Seating",
      description: "Comfortable seating arrangements for up to 60 people"
    },
    {
      icon: "🎯",
      title: "Professional Setting",
      description: "Professional and quiet setting for productive meetings"
    },
    {
      icon: "🖥️",
      title: "Equipment Available",
      description: "Projector, sound system, and whiteboards available"
    }
  ];

  return (
    <section className="conference-section">
      <div className="container">
        <div className="conference-grid">
          <div className="conference-content">
            <h2>Conference & Meetings</h2>
            <p className="conference-intro">
              Talali Lodge features a conference room with a capacity of up to 60 people, ideal for:
            </p>
            
            <div className="event-types">
              {eventTypes.map((type, index) => (
                <span key={index} className="event-badge">{type}</span>
              ))}
            </div>
            
            <div className="conference-features">
              <h3>Conference Facilities</h3>
              <div className="features-list">
                {features.map((feature, index) => (
                  <div key={index} className="feature-item">
                    <div className="feature-icon">{feature.icon}</div>
                    <div className="feature-text">
                      <h4>{feature.title}</h4>
                      <p>{feature.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            
            <div className="conference-cta">
              <button className="btn-primary">Inquire About Conference</button>
            </div>
          </div>
          
          <div className="conference-image">
            <div className="image-placeholder">
              <h3>Ideal for Business Events</h3>
              <p>Up to 60 people capacity with professional amenities</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Conference;